import { array, number, object, string } from 'yup';

import {
  AlertMessageCategory,
  AlertMessageType,
  AreaType,
  Certainty,
  FloodImmediateCause,
  FloodRecordStatus,
  FloodSeverity,
  ResponseType,
  Severity,
  Urgency,
} from './alertsHeadlinesType';

export const alertShape = {
  detailKey: string(),
  messageTypeCode: number().oneOf(Object.values(AlertMessageType)),
  messageType: string(),
  productIdentifier: string(),
  phenomena: string(),
  significance: string(),
  eventTrackingNumber: string().max(4),
  officeCode: string(),
  officeName: string().nullable(),
  officeAdminDistrict: string().nullable(),
  officeAdminDistrictCode: string().nullable(),
  officeCountryCode: string().nullable(),
  eventDescription: string(),
  severityCode: number().oneOf(Object.values(Severity)),
  severity: string(),
  categories: array().of(
    object({
      category: string(),
      categoryCode: number().oneOf(Object.values(AlertMessageCategory)),
    }),
  ),
  responseTypes: array().of(
    object({
      responseType: string(),
      responseTypeCode: number().oneOf(Object.values(ResponseType)),
    }),
  ),
  urgency: string(),
  urgencyCode: number().oneOf(Object.values(Urgency)),
  certainty: string(),
  certaintyCode: number().oneOf(Object.values(Certainty)),
  effectiveTimeLocal: string().nullable(),
  effectiveTimeLocalTimeZone: string().nullable(),
  expireTimeLocal: string(),
  expireTimeLocalTimeZone: string(),
  expireTimeUTC: number(),
  onsetTimeLocal: string().nullable(),
  onsetTimeLocalTimeZone: string().nullable(),
  flood: object({
    floodLocationId: string().nullable(),
    floodLocationName: string(),
    floodSeverityCode: string().oneOf(Object.values(FloodSeverity)).nullable(),
    floodSeverity: string().nullable(),
    floodImmediateCauseCode: string().oneOf(Object.values(FloodImmediateCause)).nullable(),
    floodImmediateCause: string().nullable(),
    floodRecordStatusCode: string().oneOf(Object.values(FloodRecordStatus)).nullable(),
    floodRecordStatus: string(),
    floodStartTimeLocal: string().nullable(),
    floodStartTimeLocalTimeZone: string().nullable(),
    floodCrestTimeLocal: string().nullable(),
    floodCrestTimeLocalTimeZone: string().nullable(),
    floodEndTimeLocal: string().nullable(),
    floodEndTimeLocalTimeZone: string().nullable(),
  }).nullable(),
  areaTypeCode: string().oneOf(Object.values(AreaType)),
  latitude: number().nullable(),
  longitude: number().nullable(),
  areaId: string(),
  areaName: string(),
  ianaTimeZone: string().nullable(),
  adminDistrictCode: string().nullable(),
  adminDistrict: string().nullable(),
  countryCode: string(),
  countryName: string(),
  headlineText: string(),
  source: string(),
  disclaimer: string().nullable(),
  issueTimeLocal: string(),
  issueTimeLocalTimeZone: string(),
  identifier: string(),
  processTimeUTC: number(),
  endTimeLocal: string().nullable(),
  endTimeLocalTimeZone: string().nullable(),
  endTimeUTC: number().nullable(),
  synopsis: string().nullable(),
  supplement: object({
    tornado: string().optional(),
    thunderstormDamageThreat: string().optional(),
    hailThreat: string().optional(),
    maxHailSize: string().optional(),
    windThreat: string().optional(),
    maxWindGust: string().optional(),
    wind: string().optional(),
    flashFlood: string().optional(),
    flashFloodDamageThreat: string().optional(),
    expectedRainfall: string().optional(),
    damFailure: string().optional(),
    leveeFailure: string().optional(),
    waterspout: string().optional(),
    hail: string().optional(),
    landspout: string().optional(),
  }).nullable(),
  polygon: array()
    .of(
      object({
        lat: number(),
        lon: number(),
      }),
    )
    .nullable(),
  texts: array().of(
    object({
      description: string(),
      instruction: string().nullable(),
      languageCode: string(),
      overview: string().nullable(),
    }),
  ),
};
